import { memo } from 'react';

import { dropdownMenuItem } from '@air/primitive-dropdown-menu';
import { Switch } from '@air/primitive-switch';

export type ViewVisibilityHeaderToggleProps = {
  id: string;
  label: string;
  onToggle: () => void;
  isToggleOn: boolean;
};
export const ViewVisibilityHeaderToggle = memo(
  ({ id, label, onToggle, isToggleOn }: ViewVisibilityHeaderToggleProps) => {
    return (
      <button
        className={dropdownMenuItem({ size: 'small', className: 'w-full' })}
        // biome-ignore lint/plugin/no-compound-data-testid: pre-existing — Cypress specs query this interpolated value directly; renaming requires updating those specs
        data-testid={`VISIBILITY_TOGGLE_HEADER-${id}`}
        data-id={id}
        onClick={onToggle}
        type="button"
      >
        {/* Class twins keep the flag-off row untouched; the redesign only bolds and darkens the label. */}
        <div className="flex min-w-0 grow truncate ui2026:font-medium ads:text-primary text-14 ui2026:text-gray-12">
          {label}
        </div>
        <div className="ml-2 shrink-0">
          <Switch
            aria-readonly
            checked={isToggleOn}
            data-id={id}
            data-testid="VISIBILITY_TOGGLE_SWITCH"
            id={id}
            name={id}
          />
        </div>
      </button>
    );
  },
);

ViewVisibilityHeaderToggle.displayName = 'ViewVisibilityHeaderToggle';
